import React from 'react'
import { t } from 'i18next'
import { Callout } from '@node-space/storybook-components/dist/Callout'
import { Input, InputProps } from '@node-space/storybook-components/dist/Input'
import { Description } from 'components/Text'

interface SignatoryEmailSectionProps {
  emailAddress: string
  isEmailMatching: boolean
  emailSent: boolean
  contact: string
  preferencesReference: string | undefined
  emailField: InputProps
}

export const SignatoryEmailSection = ({
  emailAddress = '',
  isEmailMatching,
  emailSent,
  contact,
  preferencesReference,
  emailField,
}: SignatoryEmailSectionProps) => {
  return (
    <>
      <Input {...emailField} disabled={emailAddress !== '' || emailSent} />

      {!isEmailMatching && (
        <Callout
          state={emailSent || preferencesReference ? 'success' : 'info'}
          showCloseButton={false}
        >
          <Description>
            {t(
              emailSent && !preferencesReference
                ? 'verification.appointSignatory.documentsInformation.successEmail'
                : 'verification.appointSignatory.documentsInformation.introduction',
              { contact: emailSent ? emailAddress : contact }
            )}
          </Description>
        </Callout>
      )}
    </>
  )
}
